import React, { useState } from 'react';
import styled from 'styled-components';
import flat1 from '../assets/flat1.png';
import media from 'styled-media-query';

const Content = styled.div`
	width: 100%;
	margin-top : 40px;
	min-height : 50vh;
	display: grid;
	grid-template-columns: 1fr 1fr;
	${media.lessThan('medium')`
		grid-template-columns : 1fr;
	`}
`;

const Text = styled.div`
	width : 100%;
	text-align : left;
	${media.lessThan('medium')`
		width: 100%;
		text-align : left;
	`}
`;

const P = styled.p`
	margin-top: 10px;
`;

const Img = styled.img`
	width: 100%;
	${media.lessThan('medium')`
		width: 80%;
		text-align : center;
		margin: 0 auto;
	`}
`;

const Badge = () => {
	const [badgeContent] = useState({
		title: 'Temukan Proyek dan Layanan yang Engkau Butuhkan',
		content: 'Anda dapat memposting Layanan yang Anda sediakan dan orang-orang yang membutuhkan layananmu akan melihatnya. Anda juga dapat memposting proyek untuk mendapatkan orang yang akan membantu pekerjaan Anda.'
	});

	return(
		<Content>
			<Text>
				<h2>{ badgeContent.title }</h2>
				<P>{ badgeContent.content }</P>
			</Text>
			<Img src={flat1} alt="bg"/>
		</Content>
	);
}

export default Badge;